export const getEmissionsklasse = (emission: number): string => {
  const Emissionsklasse = Emissionsklassen.find(
    ({ maximum }) => emission <= maximum
  );
  return Emissionsklasse ? Emissionsklasse.name : "G";
};

const Emissionsklassen = [
  { name: "A", minimum: 0, maximum: 0 },
  { name: "B", minimum: 1, maximum: 95 },
  { name: "C", minimum: 96, maximum: 115 },
  { name: "D", minimum: 116, maximum: 135 },
  { name: "E", minimum: 136, maximum: 155 },
  { name: "F", minimum: 156, maximum: 175 },
];
